module.exports = __webpack_public_path__ + "451d0d774889b78c81b0c5c7ed439d23.svg";